function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import cx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { getComponentType, getUnhandledProps } from '../lib';

/**
 * Button groups can contain conditionals.
 */
var ButtonOr = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    text = props.text;
  var classes = cx('or', className);
  var rest = getUnhandledProps(ButtonOr, props);
  var ElementType = getComponentType(props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes,
    "data-text": text,
    ref: ref
  }));
});
ButtonOr.displayName = 'ButtonOr';
ButtonOr.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** Additional classes. */
  className: PropTypes.string,
  /** Or buttons can have their text localized, or adjusted by using the text prop. */
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default ButtonOr;
//# sourceMappingURL=ButtonOr.js.map